import { gql } from '@apollo/client';

export const Q_EMPLEADOS = gql`
  query Empleados($page: Int, $pageSize: Int, $filter: EmpleadoFilter, $sort: EmpleadoSort) {
    empleados(page: $page, pageSize: $pageSize, filter: $filter, sort: $sort) {
      totalCount
      page
      pageSize
      edges {
        node {
          id
          legajo
          nombre
          apellido
          dni
          cuil
          email
          telefono
          empresaId
          sucursalId
          puesto
          estado
          fechaIngreso
          deletedAt
        }
      }
    }
  }
`;

export const Q_EMPLEADO_BY_ID = gql`
  query EmpleadoById($id: ID!) {
    empleadoById(id: $id) {
      id
      legajo
      nombre
      apellido
      dni
      cuil
      email
      telefono
      direccion
      fechaNacimiento
      fechaIngreso
      empresaId
      sucursalId
      puesto
      categoria
      salario
      estado
      notas
      avatarUrl
      createdAt
      updatedAt
      deletedAt
    }
  }
`;
